"use client"

import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { CircleIcon } from "lucide-react"

import { cn } from "../../lib/utils"
import PropTypes from "prop-types"

function RadioGroup({
  className,
  ...props
}) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("grid gap-3", className)}
      {...props}
    />
  )
}

RadioGroup.propTypes = {
  className: PropTypes.string,
}

function RadioGroupItem({ className, ...props }) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      style={{
        width: "16px", // bigger size than default (size-4 ~ 16px)
        height: "16px",
        borderRadius: "50%",
        border: "1px solid #ccc",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease-in-out",
      }}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: "#2563eb", // Tailwind's primary blue
        }}
      />
    </RadioGroupPrimitive.Item>
  );
}


RadioGroupItem.propTypes = {
  className: PropTypes.string,
}

export { RadioGroup, RadioGroupItem }
